"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastTransactionProvider = exports.LastTransactionContext = void 0;
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var Lang_js_1 = require("../Lang.js");
exports.LastTransactionContext = (0, react_1.createContext)({
    transaction: null,
    isLoading: false,
    message: null,
});
var LastTransactionProvider = function (_a) {
    var children = _a.children;
    var _b = (0, react_1.useState)(null), transaction = _b[0], setTransaction = _b[1];
    var _c = (0, react_1.useState)(true), isLoading = _c[0], setIsLoading = _c[1];
    var _d = (0, react_1.useState)(null), message = _d[0], setMessage = _d[1];
    (0, react_1.useEffect)(function () {
        var _a;
        var url = '/api/donations/getLastTransaction';
        var type = (_a = document.getElementById('donation-form')) === null || _a === void 0 ? void 0 : _a.getAttribute('type');
        if (type) {
            url += '?type=' + type;
        }
        axios_1.default
            .get(url)
            .then(function (_a) {
            var data = _a.data;
            if (data.status === 'success' && data.transaction) {
                setTransaction(data.transaction);
                var t = data.transaction;
                var amt = '$' + t.amount.toLocaleString('us', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                var dt = new Date(t.created).toLocaleDateString(document.documentElement.lang);
                if (type == t.type) {
                    setMessage((0, Lang_js_1.__)('Your last {type} transaction was for {amount} on {date}')
                        .replace('{type}', (0, Lang_js_1.__)(t.type).toLowerCase())
                        .replace('{amount}', amt)
                        .replace('{date}', dt));
                }
                else {
                    setMessage((0, Lang_js_1.__)('Your last transaction was a {type} for {amount} on {date}')
                        .replace('{type}', (0, Lang_js_1.__)(t.type).toLowerCase())
                        .replace('{amount}', amt)
                        .replace('{date}', dt));
                }
            }
        })
            .catch(function (err) {
            var _a;
            console.warn(err);
            setMessage(((_a = err.response) === null || _a === void 0 ? void 0 : _a.status) === 401
                ? (0, Lang_js_1.__)('Please log in to view your most recent transaction')
                : (0, Lang_js_1.__)('Error loading last transaction'));
        })
            .finally(function () { return setIsLoading(false); });
    }, []);
    return (react_1.default.createElement(exports.LastTransactionContext.Provider, { value: { transaction: transaction, isLoading: isLoading, message: message } }, children));
};
exports.LastTransactionProvider = LastTransactionProvider;
exports.default = exports.LastTransactionContext;
